import { render, staticRenderFns } from "./veStuLiteraryAwardAdmin.vue?vue&type=template&id=6d31c4f8&scoped=true"
import script from "./veStuLiteraryAwardAdmin.vue?vue&type=script&lang=js"
export * from "./veStuLiteraryAwardAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d31c4f8",
  null
  
)

export default component.exports